import { call } from '@redux-saga/core/effects'
import { AxiosError } from 'axios'
import { toastr } from 'react-redux-toastr'

export default function* handleErrorSaga(error: AxiosError | any) {
  if (error?.response) console.error(error.response)
  yield call(toastr.error, 'Server error', error.message)
}
